// SideBarMobile.tsx
import React from 'react';
import Box from '@mui/material/Box';
import { Drawer } from '@mui/material';
import SideBarItems from './SideBarItems';
import { ToolBarColor } from '../../../helpers/Themes';
import { User } from '../../../workers/ApiWorker';

interface SideBarMobileProps {
    handleDrawerClose: () => void;
    drawerOpen: boolean;
    drawerWidth: number;
    user?: User;
}

const SideBarMobile: React.FC<SideBarMobileProps> = ({
    drawerOpen,
    handleDrawerClose,
    drawerWidth,
    user,
}) => {
    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    overflowY: 'unset',
                    backgroundColor: ToolBarColor, // Desired color
                    backgroundImage: 'none', // Ensure no background image
                },
            }}
            anchor={'left'}
            open={drawerOpen}
            onClose={handleDrawerClose}
        >
            <Box role="presentation">
                <SideBarItems
                    isMobile={true}
                    handleDrawerClose={handleDrawerClose}
                    user={user}
                ></SideBarItems>
            </Box>
        </Drawer>
    );
};

export default SideBarMobile;
